<template>
  <div class="col-12">
    <div class="card">
      <div class="p-grid">
        <div class="card p-col-12">
          <Success
        v-if="
          
          this.success &&
          this.success.length > 0
        "
        :success="this.success"
      />
      <Errors
        v-if="
          
          this.errors &&
          this.errors.length > 0 
        "
        :errors="this.errors"
      />
          <DataTable
            :value="combinados"
            :loading="loading"
            :lazy="true"
            :paginator="true"
            :rows="tamPagina"
            :totalRecords="totalRecords"
            :selection.sync="bonoSelected"
            class="p-datatable-responsive"
            selectionMode="single"
            dataKey="id"
            @page="onPage($event)"
            @row-select="onRowClick"
            @row-unselect="onRowClick(null)"
            :autoLayout="true"
          >
            <template #header>
              <div class="table-header text-center">
                {{ $t("cuentaYFacturacion.usosConsumo.titulo") }}
              </div>
            </template>

            <template #empty>
              {{ $t("common.noResultados") }}
            </template>

            <Column
              field="tipoCombinado"
              :header="$t('cuentaYFacturacion.usosConsumo.tipoCombinado')"
            >
              <template #body="slotProps">
                {{ slotProps.data.tipo }}
              </template>
            </Column>
            <Column
              field="nombre"
              :header="$t('cuentaYFacturacion.usosConsumo.nombre')"
            >
              <template #body="slotProps">
                {{ slotProps.data.nombre }}
              </template>
            </Column>
            <Column
              field="fechaFin"
              :header="$t('cuentaYFacturacion.usosConsumo.fechaFin')"
            >
              <template #body="slotProps">
                <span class="p-column-title">{{
                  $t("cuentaYFacturacion.usosConsumo.fechaFin")
                }}</span>
                {{ getFormattedDateShort(slotProps.data.fechaFin != null ? slotProps.data.fechaFin : slotProps.data.contrato.fechaFin) }}
              </template>
            </Column>
            <Column
              field="usosTotales"
              :header="$t('cuentaYFacturacion.usosConsumo.usosTotales')"
            >
              <template #body="slotProps">
                {{ slotProps.data.numeroUsos || 0 }}
              </template>
            </Column>
            <Column
              field="usos"
              :header="$t('cuentaYFacturacion.usosConsumo.usos')"
            >
              <template #body="slotProps">
                {{ slotProps.data.contadorUsos || 0 }}
              </template>
            </Column>
            <Column
              field="usosRestantes"
              :header="$t('cuentaYFacturacion.usosConsumo.usosRestantes')"
            >
              <template #body="slotProps">
                {{
                  (slotProps.data.numeroUsos || 0) -
                  (slotProps.data.contadorUsos || 0)
                }}
              </template>
            </Column>
          </DataTable>
        </div>
        <div class="p-col-8 p-offset-2 p-field" v-if="bonoSelected!=null">
          <div class="p-inputgroup">
            <label for="avisoUsos"
              ><b>{{ $t("cuentaYFacturacion.usosConsumo.avisoUsos") }}</b></label
            >
            <InputText
              class="input"
              id="avisoUsos"
              type="number"
              min="0"
              max="100"
              :disabled="saveAviso"
              v-model="avisoUsos"
              @change.prevent="onAvisoUsosChange"
            />
            <Button icon="pi pi-save" @click="onClickModificarAviso"/>
            <i v-if="saveAviso" class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DatesMixin from "@/utils/dates";
import { GET_BONOS_BY_ID_LEGAL_CLIENTE, MODIFICA_AVISO_LIMITE_USUOS } from "@/graphQLQueries/CombinadosQueries.js";
import Success from "@/components/utilidades/Success.vue";
import Errors from "@/components/utilidades/Errors.vue";

export default {
  name: "DatosContacto",
  components: {
    Success,
    Errors,
  },
  mixins: [DatesMixin],
  data() {
    return {
      numPagina: 0,
      tamPagina: 10,
      sort: [],
      loading: false,
      totalRecords: 0,
      avisoUsos: 0,
      combinados: [],
      saveAviso:false,
      bonoSelected: null,
      success:[],
      errors:[]
    };
  },
  methods: {
    search() {
      this.loading = true;
      this.$apollo.queries.combinados.refetch();
    },
    getFecha(fechaFin,fechaFinContrato){
      let fecha = ''
      if (fechaFin != null)
        fecha = this.getFormattedDateShort(fechaFin)
      if (fechaFin == null && fechaFinContrato != null)
        fecha = this.getFormattedDateShort(fechaFinContrato)
      return fecha
    },
    onPage(event) {
      this.numPagina = event.page;
    },
    onRowClick(event) {
      this.avisoUsos = event.data.avisoAlPorcentajeUsos;
      this.bonoSelected = event.data;
      console.log(event);
    },
    onAvisoUsosChange() {
      if (this.avisoUsos) {
        let auxAvisoUsos = this.avisoUsos;
        if (this.avisoUsos > 100) auxAvisoUsos = 100;
        if (this.avisoUsos < 0) auxAvisoUsos = 0;
        this.avisoUsos = auxAvisoUsos;
      }
    },
    onClickModificarAviso() {
      this.saveAviso = true;
      this.onAvisoUsosChange();
      this.$apollo
        .mutate({
          mutation: MODIFICA_AVISO_LIMITE_USUOS,
          variables: {
            editarAvisoLimiteUsosRequest : {
              idBono: this.bonoSelected.id,
              limitePorcentual: this.avisoUsos,
              tipoBono: this.bonoSelected.tipoBono
            },
          }
        })
        .then(() => {
          this.success.push(this.$i18n.t("cuentaYFacturacion.usosConsumo.saveAvisos"));
          this.saveAviso = false;
          this.$apollo.queries.combinados.refetch();
        });

    }
  },
  apollo: {
    combinados: {
      query: GET_BONOS_BY_ID_LEGAL_CLIENTE,
      variables() {
        return {
          idLegalCliente: this.$store.state.clienteIdLegal
        };
      },
      update(data) {
        this.totalRecords = data.listadoBonosByIdLegal.length;
        this.loading = false;
        // INICIO <= HOY < FIN
        return data.listadoBonosByIdLegal.filter( bono => {
          let hoy = new Date();
          let inicio = bono.fechaAlta != undefined ? new Date (bono.fechaAlta) : new Date (bono.contrato.fechaInicio);
          let fin = bono.fechaFin != undefined ? new Date (bono.fechaFin) : new Date (bono.contrato.fechaFin);
          return inicio < hoy && hoy < fin;
        });
      },
      error() {
        this.$toast.add({
          severity: "error",
          summary: this.$t("common.error.updateTitle"),
          detail: this.$t("common.error.update"),
          life: 5000,
        });
      },
    },
  },
};
</script>
